import React from 'react'
import { FormattedMessage } from 'react-intl'
import { injectIntl } from 'react-intl'

class Distribuidor extends React.Component {
    render() {
        return (
            <div className="distribuidor container">
                <h2>
                    <FormattedMessage id="quieres_convertirte_en_distribuidor" defaultMessage="¿Quieres convertirte en distribuidor?" />
                </h2>
                <a href={this.props.intl.formatMessage({ id: '_ROUTE_DISTRIBUTOR' })} className="button">
                    <FormattedMessage id="conocenos" defaultMessage="Conocenos" />
                </a>
            </div>
        )
    }
}

export default injectIntl(Distribuidor)



// WEBPACK FOOTER //
// ./src/components/home/Distribuidor.js